
export function flush(state) {
  state.categories = [];
}

export function setCategories(state, payload) {
  state.categories = payload;
}

export function setRootCategory(state, payload) {
  state.rootCategory = payload;
}

export function setCurrentCategory(state, payload) {
  state.currentCategory = payload;
}

export function setCurrentProduct(state, payload) {
  state.currentProduct = payload;
}

export function setFilterForCurrentCategory(state, payload) {
  state.filter = payload;
}

export function setSelectedFilter(state, payload) {
  state.selectedFilter = payload;
}
